import { space, SpaceProps } from 'styled-system';
import StyledChildren from '../utility/StyledChildren';
import styled from '../styled';

export default styled(StyledChildren)<SpaceProps>(space);
